import { useMemo } from 'react'

import usePageMetadata from '@hooks/usePageMetadata'
import { extractContext } from '@components/Chatbot/utils'

const useChatbotContext = () => {
  const pageMetadata = usePageMetadata()
  const chatbotContext = useMemo(
    () => extractContext(pageMetadata),
    [pageMetadata],
  )

  return chatbotContext
}

export default useChatbotContext
